import { CustomerRepository } from "../../repositories/CustomerRepository";
import { CustomerSearchResultEntity } from "../../entities/CustomerEntity";

/**
 * Search Customers Use Case
 * Searches for customers with optional filters and pagination
 */
export class SearchCustomersUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  } = {}): Promise<CustomerSearchResultEntity> {
    // Validate pagination parameters
    if (params.page !== undefined && params.page < 1) {
      throw new Error("Page number must be at least 1");
    }

    if (params.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.searchCustomers(params);
  }
}

